import { Link } from "wouter";
import { cn } from "@/lib/utils";

/**
 * The switch between campaigns and the lead lists that feed them.
 *
 * These were two sidebar entries ("Campaigns" under Tools, "Mass Outreach"
 * under Entities), which put one workflow in two places and read as two
 * unrelated features. They are one thing: a list is what a campaign is built
 * from. So the sidebar keeps a single Campaigns entry and the lists live one
 * click inside it.
 *
 * Routes rather than local tab state, so a list view is still linkable and the
 * back button behaves. `/campaigns/lists` must be registered BEFORE
 * `/campaigns/:id` in App.tsx or the id route swallows it.
 */
const TABS = [
  { href: "/campaigns", label: "Campaigns", key: "campaigns" },
  { href: "/campaigns/newsletter", label: "Newsletter", key: "newsletter" },
  { href: "/campaigns/lists", label: "Lead lists", key: "lists" },
] as const;

export function OutreachTabs({ active }: { active: "campaigns" | "newsletter" | "lists" }) {
  return (
    <nav aria-label="Outreach views" className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
      {TABS.map((t) => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            href={t.href}
            aria-current={isActive ? "page" : undefined}
            className={cn(
              "px-3 py-1.5 text-sm font-medium rounded-md transition-colors",
              isActive
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
